import { toast } from "react-toastify";
import formErrorsHandler, { formErrorLoading } from "api/global/form-errors-handler";
import defaultErrorHandler from "api/global/default-error-handler";
import {
    getCriteria,
    createCriterion,
    updateCriterion,
    deleteCriterion,
    getCriteriaProjection,
    getCriterionKeywords,
    createKeyword,
    updateKeyword,
    deleteKeyword
} from "api/menu/hr/scoring-criteria/requests";

// Action Types - Criteria
export const FETCH_CRITERIA_SUCCESS = "FETCH_CRITERIA_SUCCESS";
export const FETCH_CRITERIA_PROJECTION_SUCCESS = "FETCH_CRITERIA_PROJECTION_SUCCESS";
export const CRITERIA_REQUEST_LOADING = "CRITERIA_REQUEST_LOADING";
export const CRITERIA_REQUEST_ERRORS = "CRITERIA_REQUEST_ERRORS";
export const SET_SELECTED_CRITERION = "SET_SELECTED_CRITERION";
export const CLEAR_SELECTED_CRITERION = "CLEAR_SELECTED_CRITERION";

// Action Types - Keywords
export const FETCH_KEYWORDS_SUCCESS = "FETCH_KEYWORDS_SUCCESS";
export const KEYWORDS_REQUEST_LOADING = "KEYWORDS_REQUEST_LOADING";
export const KEYWORDS_REQUEST_ERRORS = "KEYWORDS_REQUEST_ERRORS";
export const UPDATE_KEYWORD_COUNT = "UPDATE_KEYWORD_COUNT";

// Action Creators
export const setCriteriaLoading = () => ({ type: CRITERIA_REQUEST_LOADING });
export const setKeywordsLoading = () => ({ type: KEYWORDS_REQUEST_LOADING });
export const setSelectedCriterion = (criterionId) => ({ type: SET_SELECTED_CRITERION, payload: criterionId });
export const clearSelectedCriterion = () => ({ type: CLEAR_SELECTED_CRITERION });
export const updateKeywordCount = (criterionId, count) => ({ type: UPDATE_KEYWORD_COUNT, payload: { criterionId, count } });

// Criteria Thunks
export const fetchCriteria = () => dispatch => {
    dispatch(setCriteriaLoading());
    getCriteria()
        .then(response => {
            dispatch({ type: FETCH_CRITERIA_SUCCESS, payload: response.data });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, CRITERIA_REQUEST_ERRORS));
        });
};

export const fetchCriteriaProjection = () => dispatch => {
    getCriteriaProjection()
        .then(response => {
            dispatch({ type: FETCH_CRITERIA_PROJECTION_SUCCESS, payload: response.data });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, CRITERIA_REQUEST_ERRORS));
        });
};

export const createScoringCriterion = (data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    createCriterion(data)
        .then(response => {
            dispatch(formErrorLoading(false));
            toast(`Scoring criterion "${data.category}" created`, { type: toast.TYPE.SUCCESS });
            if (callback) callback(response.data);
        })
        .catch(error => {
            dispatch(formErrorLoading(false)); // Reset loading state on error
            dispatch(formErrorsHandler(error));
            if (callback) callback(error);
        });
};

export const updateScoringCriterion = (data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    updateCriterion(data)
        .then(() => {
            dispatch(formErrorLoading(false));
            toast(`Scoring criterion "${data.category}" updated`, { type: toast.TYPE.SUCCESS });
            if (callback) callback(true);
        })
        .catch(error => {
            dispatch(formErrorLoading(false)); // Reset loading state on error
            dispatch(formErrorsHandler(error));
            if (callback) callback(error);
        });
};

export const deleteScoringCriterion = (criterionId, category, callback = false) => dispatch => {
    dispatch(setCriteriaLoading());
    deleteCriterion(criterionId)
        .then(() => {
            toast(`Scoring criterion "${category}" deleted`, { type: toast.TYPE.SUCCESS });
            if (callback) callback();
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, CRITERIA_REQUEST_ERRORS));
        });
};

// Keywords Thunks
export const fetchCriterionKeywords = (criterionId) => dispatch => {
    if (!criterionId) {
        dispatch({ type: FETCH_KEYWORDS_SUCCESS, payload: [], criterionId });
        return;
    }
    
    dispatch(setKeywordsLoading());
    getCriterionKeywords(criterionId)
        .then(response => {
            dispatch({ type: FETCH_KEYWORDS_SUCCESS, payload: response.data, criterionId });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, KEYWORDS_REQUEST_ERRORS));
        });
};

export const createScoringKeyword = (criterionId, data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    createKeyword(criterionId, data)
        .then(response => {
            dispatch(formErrorLoading(false));
            toast(`Keyword "${data.text}" added`, { type: toast.TYPE.SUCCESS });
            // Fetch updated keywords to refresh count
            dispatch(fetchCriterionKeywords(criterionId));
            if (callback) callback(response.data);
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
            if (callback) callback(error);
        });
};

export const updateScoringKeyword = (keywordId, data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    updateKeyword(keywordId, data)
        .then(() => {
            dispatch(formErrorLoading(false));
            toast(`Keyword "${data.text}" updated`, { type: toast.TYPE.SUCCESS });
            if (callback) callback(true);
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
            if (callback) callback(error);
        });
};

export const deleteScoringKeyword = (keywordId, text, criterionId, callback = false) => dispatch => {
    dispatch(setKeywordsLoading());
    deleteKeyword(keywordId)
        .then(() => {
            toast(`Keyword "${text}" deleted`, { type: toast.TYPE.SUCCESS });
            // Fetch updated keywords to refresh count
            if (criterionId) {
                dispatch(fetchCriterionKeywords(criterionId));
            }
            if (callback) callback();
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, KEYWORDS_REQUEST_ERRORS));
        });
};

// Utility actions
export const clearCriteria = () => dispatch => {
    dispatch({ type: FETCH_CRITERIA_SUCCESS, payload: [] });
};

export const clearKeywords = () => dispatch => {
    dispatch({ type: FETCH_KEYWORDS_SUCCESS, payload: [] });
};
